import { findTypeOfField, filterFieldOption } from '../derived-query/query-util';

export const REQUIRED = { label: 'Required', value: 'required' };
export const EMAIL = { label: 'Email', value: 'email' };
export const INTEGER = { label: 'Number', value: 'number' };
export const DIGITS = { label: 'Digits', value: 'digits' };
export const UNIQUE = { label: 'Unique', value: 'unique' };
export const URL = { label: 'URL', value: 'url' };
export const MINIMUM_CHAR = { label: 'Minimum Length', value: 'minlength' };
export const MAXIMUM_CHAR = { label: 'Maximum Length', value: 'maxlength' };
export const STEP = { label: 'Step', value: 'step' };

export const MINIMUM_NUMBER = { label: 'Minimum', value: 'min' };
export const MAXIMUM_NUMBER = { label: 'Maximum', value: 'max' };
export const MINIMUM_CHECK = { label: 'Minimum', value: 'mincheck' };
export const MAXIMUM_CHECK = { label: 'Maximum', value: 'maxcheck' };
export const PATTERN = { label: 'Pattern', value: 'pattern' };
export const PATTERN_ALPHABETS_ONLY = {
  label: 'Alphabets Only',
  value: 'pattern_alphabets_only',
};
export const PATTERN_NUMBERS_ONLY = {
  label: 'Numbers Only',
  value: 'pattern_numbers_only',
};
export const PATTERN_ALPHANUMERIC = {
  label: 'Alphanumeric',
  value: 'pattern_alphanumeric',
};
export const PATTERN_ALPHANUMERIC_WHITESPACES = {
  label: 'Alphanumeric with Whitespaces',
  value: 'pattern_alphanumeric_whitespaces',
};
export const PATTERN_ALPHANUMERIC_UNDERSCORES = {
  label: 'Alphanumeric with Underscores',
  value: 'pattern_alphanumeric_underscores',
};
export const ACCEPT = { label: 'Accept File Type', value: 'accept' };
export const PHONE_NUMBER = { label: 'Phone Number', value: 'validPhoneNumber' };
export const PASSWORD_CAPITAL_LETTER = {
  label: 'Includes Uppercase Character',
  value: 'passwordCapitalLetter',
};
export const PASSWORD_LOWER_LETTER = {
  label: 'Includes Lowercase Character',
  value: 'passwordLowerLetter',
};
export const PASSWORD_NUMBER = { label: 'Includes Number', value: 'passwordNumber' };
export const PASSWORD_SPECIAL_CHARACTER = {
  label: 'Includes Special Character',
  value: 'passwordSpecialCharacter',
};
export const SLUG = { label: 'SLUG', value: 'slug' };
export const JSON = { label: 'JSON', value: 'json' };
export const MARKDOWN = { label: 'MARKDOWN', value: 'markdown' };
// export const EXTENSION = { label: 'Accept File Ext.', value: 'extension' };

export const addRule = (rules) => {
  const newRuleObj = {
    id: rules.length + 1,
    field: '',
    key: '',
    value: '',
    message: '',
  };
  rules.push(newRuleObj);
  return rules;
};

export const checkFieldTypeAndPrepareRuleOptions = (fields, selectedField) => {
  const fieldType = findTypeOfField(fields, selectedField);
  if (!fieldType) {
    return [];
  }

  switch (fieldType) {
    case 'text':
      return [
        REQUIRED,
        EMAIL,
        MINIMUM_CHAR,
        MAXIMUM_CHAR,
        URL,
        PATTERN,
        PATTERN_ALPHABETS_ONLY,
        PATTERN_NUMBERS_ONLY,
        PATTERN_ALPHANUMERIC,
        PATTERN_ALPHANUMERIC_WHITESPACES,
        PATTERN_ALPHANUMERIC_UNDERSCORES,
      ];
    case 'large_text':
      return [REQUIRED, MINIMUM_CHAR, MAXIMUM_CHAR, PATTERN];
    case 'boolean':
      return [REQUIRED];
    case 'date':
      return [REQUIRED, MINIMUM_NUMBER, MAXIMUM_NUMBER];
    case 'number':
      return [REQUIRED, MINIMUM_NUMBER, MAXIMUM_NUMBER, PATTERN, STEP];
    case 'color':
      return [REQUIRED];
    case 'static_option':
      return [REQUIRED, MINIMUM_CHECK, MAXIMUM_CHECK];
    case 'dynamic_option':
      return [REQUIRED, MINIMUM_CHECK, MAXIMUM_CHECK];
    case 'password':
      return [
        REQUIRED,
        MINIMUM_CHAR,
        MAXIMUM_CHAR,
        PASSWORD_CAPITAL_LETTER,
        PASSWORD_LOWER_LETTER,
        PASSWORD_SPECIAL_CHARACTER,
        PASSWORD_NUMBER,
      ];
    case 'file':
    case 'image':
    case 'video_link':
      return [REQUIRED, URL, ACCEPT];
    case 'tel':
      return [REQUIRED, PHONE_NUMBER];
    case 'slug':
      return [REQUIRED, SLUG];
    case 'json':
      return [REQUIRED, JSON];
    case 'markdown':
      return [REQUIRED, MARKDOWN];
    default:
      return [REQUIRED];
  }
};

export const updateRule = (rules, id, ruleObj) => {
  rules.forEach((rule) => {
    if (rule.id === id) {
      rule.field = ruleObj.field;
      rule.key = ruleObj.key;
      rule.value = ruleObj.value;
      rule.message = ruleObj.message;
    }
  });
  return rules;
};

export const showSaveButtonValidationUtil = (props, state) => {
  const { rule } = props;
  const {
    selectedField,
    selectedRule,
    selectedRuleMessage,
    selectedRuleValueText,
    selectedRuleValueBoolean,
  } = state;
  // console.log('states', state);
  if (!selectedField) {
    console.log('1');
    return true;
  }
  if (rule.field !== selectedField.value) {
    console.log('2');
    return true;
  }

  if (!selectedRule) {
    console.log('3');
    return true;
  }

  if (rule.key !== selectedRule.value) {
    console.log('4');
    return true;
  }

  if (
    [
      'required',
      'validPhoneNumber',
      'email',
      'number',
      'digits',
      'unique',
      'url',
      'passwordCapitalLetter',
      'passwordLowerLetter',
      'passwordNumber',
      'passwordSpecialCharacter',
      'pattern_alphabets_only',
      'pattern_numbers_only',
      'pattern_alphanumeric',
      'pattern_alphanumeric_whitespaces',
      'pattern_alphanumeric_underscores',
      'slug',
      'json',
      'markdown',
    ].includes(selectedRule.value)
  ) {
    console.log('5');

    if (rule.value !== selectedRuleValueBoolean) {
      console.log('6');
      return true;
    }
  } else {
    console.log('7');
    if (rule.value.toString() !== selectedRuleValueText) {
      console.log('8');
      return true;
    }
  }

  if (rule.message !== selectedRuleMessage) {
    console.log('9');
    return true;
  }
  return false;
};

export const saveRuleUtil = (props, state) => {
  const { condition, fields } = props;
  console.log('state :>> ', state);
  const {
    selectedField,
    selectedRule,
    selectedRuleMessage,
    selectedRuleValueText,
    selectedRuleValueBoolean,
  } = state;
  let finalValue = null;
  if (!selectedField.value) {
    return { selectedFieldError: 'Please select Field', status: 'ERROR' };
  }

  if (!selectedRule) {
    return { selectedRuleError: 'Please select Rule', status: 'ERROR' };
  }

  if (!selectedRule.value) {
    return { selectedRuleError: 'Please select Rule', status: 'ERROR' };
  }

  if (
    [
      'required',
      'validPhoneNumber',
      'slug',
      'json',
      'markdown',
      'email',
      'number',
      'digits',
      'unique',
      'url',
      'passwordCapitalLetter',
      'passwordLowerLetter',
      'passwordNumber',
      'passwordSpecialCharacter',
      'pattern_alphabets_only',
      'pattern_numbers_only',
      'pattern_alphanumeric',
      'pattern_alphanumeric_whitespaces',
      'pattern_alphanumeric_underscores',
    ].includes(selectedRule.value)
  ) {
    finalValue = selectedRuleValueBoolean;
  } else {
    if (!selectedRuleValueText) {
      return { selectedRuleValueError: 'Please select the value for the rule', status: 'ERROR' };
    } else if (['minlength', 'maxlength', 'min', 'max'].includes(selectedRule.value)) {
      finalValue = parseInt(selectedRuleValueText);
    } else {
      finalValue = selectedRuleValueText;
    }
  }

  if (!selectedRuleMessage) {
    return {
      selectedRuleMessageError: 'Please give warning/error message for the rule',
      status: 'ERROR',
    };
  }

  return {
    field: selectedField.value,
    key: selectedRule.value,
    value: finalValue,
    message: selectedRuleMessage,
    status: 'SUCCESS',
  };
};

const excludedFieldName = ['createdAt', 'createdBy', 'uuid', 'updatedAt', 'isDeleted'];

const excludedFieldType = [];

export const createSelectOptionsForField = (fields) => {
  return filterFieldOption(fields, excludedFieldType, excludedFieldName);
};
